export default "__VITE_ASSET__665e2578__"